module.exports = __webpack_public_path__ + "img/CosmoSuccessTurtle.ad17acf6.png";